import React from 'react'
import { Link } from "react-router-dom";
import LOGO from "../../assets/images/logo.svg"
import { home } from '../../config/routingConsts';

const Header = () => {

  const ToggleOn = () =>{
    document.body.classList.toggle('mobile-open')
  }

  return (
    <header className={"site-header login-header" }>
      <div className="header-top">
        <div className="container">
          <div className="header-inner">
            <Link className="logo" to = {home}><img src={LOGO} alt="logo"/></Link>
        </div>
      </div>
      </div>
      
    </header>
  )
}

export default Header